import { IOrderDetailsApiDto } from '../api.types'
import { EOrderStatusName } from '../../orderStatus'

export const getCryptoOrderDetailsApiRespMock: IOrderDetailsApiDto = {
    refund_address: null,
    amount_base: '30.27545025',
    is_default_rule: false,
    unique_reference: 'OC9CTC',
    amount_quote: '0.20701247',
    pair: {
        name: 'XMRBTC',
        base: {
            code: 'XMR',
            name: 'monero',
            min_confirmations: 10,
            is_crypto: true,
            minimal_amount: '0.10000000',
            maximal_amount: '7200.00000000',
            is_base_of_enabled_pair: true,
            is_quote_of_enabled_pair: true,
            has_enabled_pairs: true,
            is_base_of_enabled_pair_for_test: true,
            is_quote_of_enabled_pair_for_test: true,
            has_enabled_pairs_for_test: true,
            withdrawal_fee: '0.01500000',
            extra_id: null,
        },
        quote: {
            code: 'BTC',
            name: 'bitcoin',
            min_confirmations: 2,
            is_crypto: true,
            minimal_amount: '0.00100000',
            maximal_amount: '100.00000000',
            is_base_of_enabled_pair: true,
            is_quote_of_enabled_pair: true,
            has_enabled_pairs: true,
            is_base_of_enabled_pair_for_test: true,
            is_quote_of_enabled_pair_for_test: true,
            has_enabled_pairs_for_test: true,
            withdrawal_fee: '0.00050000',
            extra_id: null,
        },
        fee_ask: 0.04,
        fee_bid: 0.04,
    },
    withdraw_address: {
        type: 'W',
        name: '',
        address:
            '45FwZDwdpnQHsow5R9gethidLAV3BeCvS14DKhHaxixzQ1QtbA4eza9PFUkw2XtegvhbbqjajW23hCFwjrn8xXsPCxo15YY',
        currency_code: 'XMR',
        destination_tag: null,
        extra_id: null,
        memo: null,
    },
    deposit_address: {
        type: 'D',
        name: '',
        address: '3AerYPzYumaTDx9PNsKh7g6DQdjLRqeYFu',
        currency_code: 'BTC',
        destination_tag: null,
        extra_id: null,
        memo: null,
    },
    created_on: '2020-12-23T03:13:43.340527Z',
    from_default_rule: false,
    payment_window: 15,
    payment_deadline: '2020-12-23T03:28:43.340527Z',
    kyc_deadline: null,
    status_name: [[16, EOrderStatusName.COMPLETED]],
    transactions: [
        {
            created_on: '2020-12-23T05:31:30.827920Z',
            modified_on: '2020-12-23T05:55:06.841195Z',
            type: 'W',
            address_to: 12123,
            tx_id: '05541c3bc1feacaae1eb4ace6760cc285b6119663b265c296bb880e40681d4b7',
            confirmations: 10,
            amount: '30.27545025',
            is_verified: false,
            is_completed: false,
            time: '2020-12-23T05:31:30.827312Z',
            currency: 'XMR',
        },
        {
            created_on: '2020-12-23T03:14:07.612926Z',
            modified_on: '2020-12-23T05:31:29.411897Z',
            type: 'D',
            address_to: 28184,
            tx_id: 'b77acc48b1a615fa2270014ac42fdc9e9b3365ba33822aeb5989431765266d37',
            confirmations: 15,
            amount: '0.20701247',
            is_verified: false,
            is_completed: false,
            time: '2020-12-23T03:13:53Z',
            currency: 'BTC',
        },
    ],
    referral_code: [
        {
            code: 'RYH64NZ2A5F',
            created_on: '2020-12-23T03:13:43.214864Z',
            modified_on: '2020-12-23T03:13:43.214898Z',
        },
    ],
    withdrawal_fee: 0.015,
    withdrawal_fee_quote: 0.0001024359,
    user_provided_amount: 1,
    amount_usd: 4878.763799069125,
    amount_btc: 0.20701247,
    amount_eur: 4002.8962492608516,
    amount_quote_fee: 0.0,
    payment_url: null,
    display_refund_address: false,
    price: {
        rate: 0.00682906,
        rate_usd: 161.62118205,
        rate_btc: 0.00686304,
        rate_eur: 132.605110415,
    },
}
